/* RESPONSIBLE TEAM: team-messenger */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class PushCredentialSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {}
